/**
 * Fotos incrustadas en el bundle (data URLs) — único método fiable en IIS/SmarterASP.
 */

import { GALLERY_INLINE } from '../generated/galleryInline';

/** Nombre exacto del archivo (p. ej. imagen22.webp). */
export function gallerySrc(filename: string): string {
  const url = GALLERY_INLINE[filename];
  if (!url && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('[gallerySrc] no encontrado:', filename);
  }
  return url ?? '';
}
